module.exports = __webpack_public_path__ + "img/selected5-min.a89ae6b6.png";